@if (_form()) {
  <form [formGroup]="_form()">
    <div class="line m-sm:flex-wrap">
      @if (_isViewDropdown()) {
        <myre-dropdown
          class="view-selector"
          [list]="_viewOptions()"
          [ngModel]="currentView()"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="_onViewChange($event)"
        />
      }

      <myre-textbox
        formControlName="search"
        type="search"
        [placeholder]="searchPlaceholder()"
        [secondary]="true"
      >
        @if (_hasSearchTarget()) {
          <myre-actions-dropdown
            [label]="_selectedSearchTargetLabel()"
            [tagType]="_searchTargetTagType"
            [icon]="'myre-icon-arrow_down'"
            [dropdownItems]="_searchTargetItems()"
          />
        }
      </myre-textbox>

      @if (!_isViewDropdown()) {
        @for (view of views(); track view.key) {
          <myre-button
            [class.selected]="view.key === currentView()"
            [label]="view.label"
            [theme]="_ButtonTheme.Secondary"
            [attr.data-testid]="'view.' + view.key"
            (onClick)="_onViewChange(view.key)"
          />
        }
      }

      @if (areFiltersVisible()) {
        @for (filter of _inlineFilters(); track filter.key) {
          <myre-filter-item [filter]="filter" [formControlName]="filter.key" />
        }
      }

      <div class="m-flex m-flex-items:center m-gap:2 m-margin-l:auto">
        @if (useCombinedDropdown()) {
          <myre-dropdown
            [list]="[]"
            [placeholderIcon]="'myre-icon-tune'"
            class="dropdown-pagination-filter"
          >
            <ng-template
              class="template-pagination-filter"
              [dropdownTemplate]="'header'"
            >
              @if (hasOrder()) {
                <div class="group-selection">
                  <div class="title">
                    {{ _wordings._system.lists.filter.sort() }}
                  </div>

                  <ng-container *ngTemplateOutlet="orderDropdownTemplate" />
                </div>
              }

              @if (hasPagination()) {
                <div class="group-selection">
                  <div class="title">
                    {{ _wordings._system.lists.filter.paging() }}
                  </div>

                  <ng-container
                    *ngTemplateOutlet="paginationDropdownTemplate"
                  />
                </div>
              }
              @if (hasCurrencyConfig()) {
                <div class="group-selection">
                  <div class="title">{{ _wordings.label.currency() }}</div>

                  <myui-dropdown-factor
                    [currency]="currency()"
                    [currentFactor]="factor()"
                    (onChange)="updateFactor($event)"
                  />
                </div>
              }

              @for (configFilter of _configFilters(); track configFilter.key) {
                <div class="group-selection">
                  @if (!_isSwitchFilter(configFilter)) {
                    <div class="title">{{ configFilter.label }}</div>
                  }

                  <myre-filter-item
                    [filter]="configFilter"
                    [formControlName]="configFilter.key"
                  />
                </div>
              }
            </ng-template>
            <ng-template [dropdownTemplate]="'empty'" />
          </myre-dropdown>
        } @else {
          @if (!hasOrder() && hasPagination()) {
            <ng-container *ngTemplateOutlet="paginationDropdownTemplate" />
          }

          @if (!hasPagination() && hasOrder()) {
            <ng-container *ngTemplateOutlet="orderDropdownTemplate" />
          }
        }

        @if (_isViewDropdown()) {
          <myre-button
            data-testid="filter-list-toggle-filters"
            [preventDoubleClickInterval]="_NO_DOUBLE_CLICK_GUARD"
            [class.selected]="areFiltersVisible()"
            [icon]="'myre-icon-filtre'"
            [theme]="_ButtonTheme.Secondary"
            [ariaLabel]="
              _wordings._ui.filterListPaginated.filter.toggleAriaLabel()
            "
            (onClick)="_toggleFilters()"
          />
        }
      </div>
    </div>

    @if (_isFilterRowVisible()) {
      <div class="line m-sm:flex-wrap">
        <div
          class="m-flex m-flex-wrap m-flex-items:center m-gap:2 m-flex:1 m-min-width:0"
        >
          @for (filter of _rowFilters(); track filter.key) {
            <myre-filter-item
              [filter]="filter"
              [formControlName]="filter.key"
            />
          }
        </div>

        @if (filterActions(); as actions) {
          <myre-action-group
            class="filter-actions m-flex-self:start"
            [primaryButtons]="actions.primaryButtons"
            [secondaryButtons]="actions.secondaryButtons"
            [optionsButtons]="actions.optionButtons"
          />
        }
      </div>
    }
  </form>
}

<ng-template #paginationDropdownTemplate>
  <myre-dropdown
    class="paginator"
    [list]="paginationOptions()"
    [ngModel]="_itemsPerPage()"
    [disabled]="isLoading()"
    (ngModelChange)="_onPaginationChange($event)"
    [ngModelOptions]="{ standalone: true }"
  />
</ng-template>

<ng-template #orderDropdownTemplate>
  <myre-dropdown
    class="order"
    [formControl]="orderControl()"
    [list]="orderOptions()"
  />
</ng-template>
